@if(loadingService.loading()){
<div class="loader-overlay">
  <mat-spinner color="accent" diameter="50"></mat-spinner>
</div>
}
<router-outlet />
